import React, { useState, useEffect, useRef } from 'react';
import './Authentication.css';
import '../../styles/variables.css';
import '../../styles/global.css';
import { supabase, supabaseUrl, supabaseAnonKey } from '../../supabase/supabase';
import { useNavigate, Link } from "react-router-dom";
import LogoCircular from '../../assets/svgs/logo circular1.png';
import NavBar from '../../components/NavBar/NavBar';
import { useAuth } from '../../contexts/AuthContext';
//ideas
import glowinglamp from '../../assets/images/ideas/idea1.png'
import glowingbrain from '../../assets/images/ideas/idea2.png'
import designthinking from '../../assets/images/ideas/idea3.webp'
import brainthoughts from '../../assets/images/ideas/idea4.jpg'
import brainpen from '../../assets/images/ideas/idea5.jpeg'
import teamworklamp from '../../assets/images/ideas/idea6.webp'
import teamworkpaper from '../../assets/images/ideas/idea7.jpg'
import teamwork from '../../assets/images/ideas/idea10.jpg'
import notebook from '../../assets/images/ideas/idea9.jpg'
//business
import digitalpuzzle from '../../assets/images/business/business1.jpg'
import businesspuzzle from '../../assets/images/business/business2.jpg'
import digitalgraph from '../../assets/images/business/business11.jpg'
import digitalbusiness from '../../assets/images/business/business4.jpg'
import teamworkmeeting from '../../assets/images/business/business5.webp'
import hystogram from '../../assets/images/business/business6.jpg'
import growtharrow from '../../assets/images/business/business7.jpg'
import growth from '../../assets/images/business/business9.webp'
import handshake from '../../assets/images/business/business10.jpg'
//projects
import dropshipping from '../../assets/images/projects/project1.webp'
import merch from '../../assets/images/projects/project2.jpg'
import brand from '../../assets/images/projects/project3.jpg'
import crypto from '../../assets/images/projects/project4.png'
import saas from '../../assets/images/projects/project5.jpg'
import onlinecouse from '../../assets/images/projects/project6.webp'
import ebook from '../../assets/images/projects/project7.jpg'
import blog from '../../assets/images/projects/project8.jpg'
import coding from '../../assets/images/projects/project9.webp'


// import threephones from '../../assets/images/3 phones1.png'
import iphonemockup from '../../assets/images/2iphones.png'
import DownloadModal from '../../components/Buttons/DownloadModal/DownloadModal';
// import NavBar from '../../components/NavBar/NavBar'
import Hero from '../../components/Hero/Hero'
import Feature from '../../components/Feature/Feature'
import Business from '../../components/Business/Business'
import Footer from '../../components/Footer/Footer'
import Community from '../../components/Community/Community'
import AffiliationCard from '../../components/AffiliationCard/AffiliationCard'
import Categories from '../../components/Categories/Categories'
import Ads from '../../components/Ads/Ads'
import DownloadButtons from '../../components/DownloadButtons/DownloadButtons'
import { useLanguage } from "../../contexts/LanguageContext";
import { FaGlobe } from "react-icons/fa";
import { FiArrowLeft } from 'react-icons/fi';
import LanguageSwitcher from '../../components/LanguageSwitcher/LanguageSwitcher';
import FloatingWebsiteNavigation from '../../components/FloatingWebsiteNavigation/FloatingWebsiteNavigation';
import PhoneInput from 'react-phone-number-input';
import 'react-phone-number-input/style.css';





const Authentication = () => {
  const [isLogin, setIsLogin] = useState(true);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [phone, setPhone] = useState('');
  const [name, setName] = useState('');
  const [columns, setColumns] = useState(4);
  const [images, setImages] = useState([]);
  const [activeSection, setActiveSection] = useState(0);
  const [authError, setAuthError] = useState(""); // to display any login errors
  const containerRef = useRef(null);
  const landingRef = useRef(null);
  const isScrolling = useRef(false);
  const [landingAtTop, setLandingAtTop] = useState(true);
  const [activeIdeaIndex, setActiveIdeaIndex] = useState(0);
  const ideaIntervalRef = useRef(null);
  const navigate = useNavigate();
  const [mobileAuthOpen, setMobileAuthOpen] = useState(false);
  const [isAuthOpen, setIsAuthOpen] = useState(false);
  const dropdownRef = useRef(null);

  // Sign-up mode state
  const [isSignUpMode, setIsSignUpMode] = useState(false);
  const [username, setUsername] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  // OTP flow state
  const [signInMethod, setSignInMethod] = useState('email'); // 'email' or 'phone'
  const [phoneNumber, setPhoneNumber] = useState('');

  // Use AuthContext for Supabase authentication
  const { currentUser, userProfile } = useAuth();

  //language globe 
  const { translations: t, changeLanguage, language } = useLanguage();
  const availableLanguages = [
    { code: "en", label: "English" },
    { code: "fr", label: "Français" },
    { code: "ar", label: "العربية" }
  ];


  const ideas = [
    {
      id: 1,
      staticText: "Post your next",
      changingText: "innovative new idea",
      images: [
        { id: 1, src: glowinglamp, height: 320 },
        { id: 2, src: glowingbrain, height: 280 },
        { id: 3, src: brainpen, height: 360 },
        { id: 4, src: brainthoughts, height: 300 },
        { id: 5, src: designthinking, height: 340 },
        { id: 6, src: teamworklamp, height: 290 },
        { id: 7, src: teamworkpaper, height: 310 },
        { id: 8, src: teamwork, height: 350 },
        { id: 9, src: notebook, height: 270 }

      ]
    },
    {
      id: 2,
      staticText: "Post your next",
      changingText: "business solution",
      images: [
        { id: 10, src: digitalbusiness, height: 330 },
        { id: 11, src: businesspuzzle, height: 290 },
        { id: 12, src: digitalgraph, height: 370 },
        { id: 13, src: digitalpuzzle, height: 310 },
        { id: 14, src: hystogram, height: 350 },
        { id: 15, src: growtharrow, height: 300 },
        { id: 16, src: growth, height: 320 },
        { id: 17, src: handshake, height: 360 },
        { id: 18, src: teamworkmeeting, height: 280 }
      ]
    },
    {
      id: 3,
      staticText: "Post your next",
      changingText: "creative project",
      images: [
        { id: 19, src: dropshipping, height: 340 },
        { id: 20, src: brand, height: 300 },
        { id: 21, src: merch, height: 380 },
        { id: 22, src: crypto, height: 320 },
        { id: 23, src: saas, height: 360 },
        { id: 24, src: onlinecouse, height: 310 },
        { id: 25, src: ebook, height: 330 },
        { id: 26, src: blog, height: 370 },
        { id: 27, src: coding, height: 290 }
      ]
    }
  ];

  useEffect(() => {
    // Auto-rotate ideas every 3 seconds
    ideaIntervalRef.current = setInterval(() => {
      setActiveIdeaIndex(prev => (prev + 1) % ideas.length);
    }, 3000);

    return () => clearInterval(ideaIntervalRef.current);
  }, []);

  const handleDotClick = (index) => {
    clearInterval(ideaIntervalRef.current);
    setActiveIdeaIndex(index);
    // Restart auto-rotation after manual selection
    ideaIntervalRef.current = setInterval(() => {
      setActiveIdeaIndex(prev => (prev + 1) % ideas.length);
    }, 3000);
  };

  // Handle scroll events
  //    useEffect(() => {
  //   const container = containerRef.current;
  //   if (!container) return;

  //   const onContainerWheel = (e) => {

  //     if (activeSection === 2) return;

  //     e.preventDefault();
  //     if (isScrolling.current) return;

  //     const delta = Math.sign(e.deltaY);
  //     const next  = Math.min(Math.max(activeSection + delta, 0), 2);
  //     if (next !== activeSection) {
  //       isScrolling.current = true;
  //       setActiveSection(next);
  //       container.scrollTo({
  //         top: next * window.innerHeight,
  //         behavior: 'smooth'
  //       });
  //       setTimeout(() => { isScrolling.current = false; }, 800);
  //     }
  //   };

  //   container.addEventListener('wheel', onContainerWheel, { passive: false });
  //   return () => {
  //     container.removeEventListener('wheel', onContainerWheel);
  //   };
  // }, [activeSection]);
  // useEffect(() => {
  //   const landing = landingRef.current;
  //   const container = containerRef.current;
  //   if (!landing || !container) return;

  //   const onLandingWheel = (e) => {
  //     if (activeSection !== 2) return;

  //     if (landing.scrollTop === 0 && e.deltaY < 0) {
  //       e.preventDefault();
  //       isScrolling.current = true;
  //       const prev = 1; 
  //       setActiveSection(prev);
  //       container.scrollTo({
  //         top: prev * window.innerHeight,
  //         behavior: 'smooth'
  //       });
  //       setTimeout(() => { isScrolling.current = false; }, 800);
  //     }
  //   };

  //   landing.addEventListener('wheel', onLandingWheel, { passive: false });
  //   return () => {
  //     landing.removeEventListener('wheel', onLandingWheel);
  //   };
  // }, [activeSection]);



  useEffect(() => {
    const fetchImagesFromSupabase = async () => {
      try {
        console.log('[Authentication] Fetching masonry images from Supabase...');

        // Fetch public, unlocked posts with media from Supabase
        const { data: posts, error } = await supabase
          .from('posts')
          .select('id, user_id, media_names, is_locked, is_private')
          .eq('is_locked', false)
          .eq('is_private', false)
          .not('media_names', 'is', null)
          .order('created_at', { ascending: false })
          .limit(500);

        if (error) {
          console.error('[Authentication] Supabase posts fetch error:', error);
          return;
        }

        if (!posts || posts.length === 0) {
          setImages([]);
          return;
        }

        const imageDocs = [];
        let id = 1;

        posts.forEach((post) => {
          if (!Array.isArray(post.media_names) || post.media_names.length === 0) return;

          post.media_names.forEach((filename) => {
            if (typeof filename !== 'string') return;

            const lower = filename.toLowerCase();
            const isImage =
              lower.endsWith('.jpg') ||
              lower.endsWith('.jpeg') ||
              lower.endsWith('.png') ||
              lower.endsWith('.webp') ||
              lower.endsWith('.gif') ||
              lower.endsWith('.avif');

            if (!isImage) return;

            const src = `https://dtskgpqvvxcbtcsmedrq.supabase.co/storage/v1/object/public/post-media/${post.user_id}/${filename}`;

            imageDocs.push({
              id: id++,
              src,
              height: Math.floor(Math.random() * 150) + 250,
            });
          });
        });

        if (imageDocs.length === 0) {
          setImages([]);
          return;
        }

        const shuffled = imageDocs.sort(() => 0.5 - Math.random());
        const selected = shuffled.slice(0, 100);
        setImages(selected);
      } catch (error) {
        console.error('[Authentication] Error fetching images from Supabase:', error);
      }
    };

    fetchImagesFromSupabase();
  }, []);


  // useEffect(() => {
  //   const handleResize = () => {
  //     if (window.innerWidth < 768) setColumns(1);
  //     else if (window.innerWidth < 1024) setColumns(2);
  //     else if (window.innerWidth < 1280) setColumns(3);
  //     else setColumns(4);
  //   };

  //   handleResize();
  //   window.addEventListener('resize', handleResize);
  //   return () => window.removeEventListener('resize', handleResize);
  // }, []);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 768) setColumns(2);
      else if (window.innerWidth < 1024) setColumns(3);
      else if (window.innerWidth < 1280) setColumns(4);
      else if (window.innerWidth > 1920) setColumns(6);
      else setColumns(6);
    };

    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);




  const getColumnData = () => {
    const columnHeights = new Array(columns).fill(0);
    const columnItems = new Array(columns).fill().map(() => []);

    images.forEach((image) => {
      const shortestColumnIndex = columnHeights.indexOf(Math.min(...columnHeights));
      columnItems[shortestColumnIndex].push(image);
      columnHeights[shortestColumnIndex] += image.height;
    });

    return columnItems;
  };

  // Remove any broken images from state so they disappear from both masonry sections
  const handleImageError = (badId) => {
    setImages((prev) => prev.filter((img) => img.id !== badId));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log(isLogin ? 'Logging in' : 'Signing up', { email, password, name, phone });
  };

  const getMiddleTranslateY = (index) => {
    switch (index) {
      case 1: return 40;
      case 2: return 100;
      case 3: return 160;
      case 4: return 100;
      case 5: return 40;
      default: return 0;
    }
  };
  //  SUPABASE AUTH HANDLERS BELOW
  // ───────────────────────────────────────────────────────────────────────

  // 1) Email/Password login
  const handleEmailLogin = async (e) => {
    e.preventDefault();
    if (isSubmitting) return;
    setAuthError("");
    setIsSubmitting(true);
    try {
      const { error } = await supabase.auth.signInWithPassword({
        email,
        password
      });
      if (error) {
        // Customize error message for invalid credentials
        if (error.message && (error.message.toLowerCase().includes('invalid') || error.message.toLowerCase().includes('credentials'))) {
          throw new Error('email or password is incorrect');
        }
        throw error;
      }
      console.log("Logged in successfully");
      navigate("/feed"); // ← redirect on success
    } catch (error) {
      console.error("Email login error:", error);
      setAuthError(error.message || "Unable to sign in");
    } finally {
      setIsSubmitting(false);
    }
  };

  // Email/password sign-up handler using Supabase Edge Function
  const handleEmailSignup = async (e) => {
    e.preventDefault();
    if (isSubmitting) return;
    setAuthError("");

    if (!email || !password) {
      setAuthError("Email and password are required.");
      return;
    }

    if (password.length < 6) {
      setAuthError("Password must be at least 6 characters long.");
      return;
    }

    if (password !== confirmPassword) {
      setAuthError("Passwords do not match.");
      return;
    }

    try {
      setIsSubmitting(true);

      const { error } = await supabase.functions.invoke('signup', {
        body: {
          email,
          password,
          username: username || undefined,
          display_name: username || email
        }
      });

      if (error) {
        console.error('Signup edge function error:', error);
        throw error;
      }

      // After successful signup, log the user in and redirect to setup page
      const { data: signInData, error: signInError } = await supabase.auth.signInWithPassword(
        { email, password }
      );

      if (signInError) {
        console.error('Sign-in after signup error:', signInError);
        throw signInError;
      }

      // Optional: refresh profile context for the newly signed-up user
      try {
        const userId = signInData?.user?.id;
        if (userId) {
          // Mark this user as needing setup via stats flag (non-breaking for existing profiles)
          const { data: existing } = await supabase
            .from('profiles')
            .select('stats')
            .eq('user_id', userId)
            .maybeSingle();

          const nextStats = { ...(existing?.stats || {}), is_new_user: true };
          await supabase
            .from('profiles')
            .update({ stats: nextStats })
            .eq('user_id', userId);
        }
      } catch (markErr) {
        console.warn('Could not mark profile as new user:', markErr);
      }

      setIsAuthOpen(false);
      navigate('/setup-account');
    } catch (err) {
      console.error('Email signup error:', err);
      setAuthError(err.message || 'Unable to sign up. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };

  // 2) Google OAuth login
  const handleGoogleLogin = async () => {
    if (isSubmitting) return;
    setAuthError("");
    try {
      setIsSubmitting(true);
      const postAuthPath = isSignUpMode ? '/setup-account' : '/feed';
      const { error } = await supabase.auth.signInWithOAuth({
        provider: 'google',
        options: {
          redirectTo: `${window.location.origin}${postAuthPath}`,
          queryParams: {
            prompt: 'select_account',
          },
          skipBrowserRedirect: false
        }
      });
      if (error) {
        console.error('Google OAuth error:', error);
        throw error;
      }
      // The redirect will happen automatically
    } catch (err) {
      console.error('Google sign-in error:', err);
      setAuthError(err.message || 'Google sign-in failed. Please check your Supabase configuration.');
    } finally {
      setIsSubmitting(false);
    }
  };

  // 3) Apple OAuth login
  const handleAppleLogin = async () => {
    if (isSubmitting) return;
    setAuthError("");
    try {
      setIsSubmitting(true);
      const postAuthPath = isSignUpMode ? '/setup-account' : '/feed';
      const { error } = await supabase.auth.signInWithOAuth({
        provider: 'apple',
        options: {
          redirectTo: `${window.location.origin}${postAuthPath}`,
          queryParams: {
            response_mode: 'form_post'
          },
          skipBrowserRedirect: false
        }
      });
      if (error) {
        console.error('Apple OAuth error:', error);
        throw error;
      }
      // The redirect will happen automatically
    } catch (err) {
      console.error('Apple sign-in error:', err);
      setAuthError(err.message || 'Apple sign-in failed. Please check your Supabase configuration.');
    } finally {
      setIsSubmitting(false);
    }
  };

  // 4) OTP-based login (Email or Phone via WhatsApp)
  const handleSendOtp = async (e) => {
    e?.preventDefault();
    if (isSubmitting) return;
    setAuthError('');
    setIsSubmitting(true);

    try {
      let endpoint = '';
      let body = {};

      if (signInMethod === 'email') {
        if (!email) throw new Error('Email is required');
        endpoint = 'email-login-otp-send';
        body = { email };
      } else if (signInMethod === 'phone') {
        if (!phoneNumber) throw new Error('Phone number is required');
        endpoint = 'phone-login-otp-send';
        body = { phoneNumber, method: 'whatsapp' };
      } else {
        return;
      }

      console.log(`Sending OTP via ${signInMethod} to`, body);

      const response = await fetch(`${supabaseUrl}/functions/v1/${endpoint}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${supabaseAnonKey}`,
          'apikey': supabaseAnonKey,
        },
        body: JSON.stringify(body),
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.error || 'Failed to send verification code.');
      }

      // Navigate to verification page
      setIsAuthOpen(false);
      navigate('/otp-verification', {
        state: {
          email: signInMethod === 'email' ? email : null,
          phoneNumber: signInMethod === 'phone' ? phoneNumber : null,
          method: signInMethod === 'email' ? 'email' : 'whatsapp'
        }
      });

    } catch (err) {
      console.error('OTP Send Error:', err);
      setAuthError(err.message || 'Failed to send verification code.');
    } finally {
      setIsSubmitting(false);
    }
  };
  //  Authentication section 3 component
  useEffect(() => {
    const animatedSection = document.getElementById('animated-section');
    if (!animatedSection) return;

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return;

        // grab each element once and check for existence
        const phone = entry.target.querySelector('.phone-image');
        const title = entry.target.querySelector('.title-animate');
        const text = entry.target.querySelector('.text-animate');
        const cta = entry.target.querySelector('.cta-button');

        phone && phone.classList.remove('animate-float-in');
        title && title.classList.remove('animate-slide-in');
        text && text.classList.remove('animate-slide-in');
        cta && cta.classList.remove('animate-fade-scale');

        // force reflow
        void entry.target.offsetWidth;

        setTimeout(() => { phone && phone.classList.add('animate-float-in'); }, 300);
        setTimeout(() => { title && title.classList.add('animate-slide-in'); }, 500);
        setTimeout(() => { text && text.classList.add('animate-slide-in'); }, 700);
        setTimeout(() => { cta && cta.classList.add('animate-fade-scale'); }, 900);
      });
    }, { threshold: 0.1 });

    observer.observe(animatedSection);
    return () => observer.unobserve(animatedSection);
  }, []);

  const toggleAuth = () => {
    setIsAuthOpen(!isAuthOpen);
    // Reset form state when closing
    if (isAuthOpen) {
      setAuthError('');
      setIsSignUpMode(false);
      setUsername('');
      setEmail('');
      setPassword('');
      setConfirmPassword('');
    }
  };

  const switchToSignUp = () => {
    setAuthError('');
    setIsSignUpMode(true);
  };

  const switchToSignIn = () => {
    setAuthError('');
    setIsSignUpMode(false);
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsAuthOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  // Listen for custom event to open mobile auth dropdown
  useEffect(() => {
    const handleOpenMobileAuth = (e) => {
      if (e.detail?.source === 'footer' || e.detail?.source === 'floatingNav') {
        setIsAuthOpen(true);
        setAuthError('');
        // Scroll to top to ensure dropdown is visible
        try {
          window.scrollTo({ top: 0, behavior: 'smooth' });
        } catch (_) {
          window.scrollTo(0, 0);
        }
      }
    };

    document.addEventListener('openMobileAuth', handleOpenMobileAuth);
    return () => {
      document.removeEventListener('openMobileAuth', handleOpenMobileAuth);
    };
  }, []);


  // helper to jump to any snap-section
  // const scrollToSection = (idx) => {
  //   if (!containerRef.current) return;
  //   containerRef.current.scrollTo({
  //     top: idx * window.innerHeight,
  //     behavior: 'smooth'
  //   });
  //   setActiveSection(idx);
  // };

  // Auth state is now handled by AuthContext, no need for separate listener

  useEffect(() => {
    document.body.dir = language === 'ar' ? 'rtl' : 'ltr';
  }, [language]);

  return (
    <>
      <div className="nav-desktop-only">
        <NavBar activeSection={activeSection} />
      </div>
      <div className="scroll-container" ref={containerRef}>
        {/* <div className="scroll-indicator">
          { (
    activeSection < 2                // always show in 0,1,2
  || (activeSection === 2 && landingAtTop)  // or at top of section 4
) && (
  <div className="scroll-indicator">
    {[0,1,2].map(i => (
      <div
        key={i}
        className={`indicator-line ${activeSection===i?'active':''}`}
        onClick={() => {
          containerRef.current.scrollTo({
            top: i * window.innerHeight,
            behavior: 'smooth'
          });
          setActiveSection(i);
        }}
      />
    ))}
  </div>
)}

        </div> */}
        <section className="auth-section">
          <div className="auth-container">
            {/* {window.innerWidth < 768 && (
              <div className="mobile-signup-toggle">
                <button onClick={() => setMobileAuthOpen(o => !o)}>
                  {mobileAuthOpen ? 'Close' : 'Sign Up'}
                </button>
              </div>
            )} */}
            <div className="masonry-header-overlay">
              <h2><span className='header-overlay-title'>iWinto</span><br /><span className='header-overlay'> {t.authHeaderSub || "A platform that empowers you... to transform your life for the better."}</span></h2>
            </div>
            <div className="masonry-wrapper">
              <div className="masonry-scroll">
                {images.length === 0 ? (
                  <p style={{ padding: 20, textAlign: 'center', fontStyle: 'italic' }}>
                    {t.loadingImages || "Loading images or none found..."}
                  </p>
                ) : (
                  getColumnData().map((column, columnIndex) => (
                    <div
                      key={columnIndex}
                      className={`masonry-column scroll-speed-${(columnIndex % 4) + 1}`}
                    >
                      {[...column, ...column].map((image, i) => (
                        <div
                          key={`${image.id}-${i}`}
                          className="masonry-item"
                          style={{ height: `${image.height}px` }}
                        >
                          <img
                            src={image.src}
                            alt={`Pin ${image.id}`}
                            onError={() => handleImageError(image.id)}
                          />
                        </div>
                      ))}
                    </div>
                  ))
                )}
              </div>
            </div>
            {/* <div className="auth-form-container">
              <div className="auth-form-wrapper">
                <div className="auth-header">
                  <div className="logo-border-radius">
                    <img src={LogoCircular} alt="logo" />
                  </div>
                  <h1>{isLogin ? "Welcome to iWinto" : "Join iWinto"}</h1>
                  <DownloadModal/>
                </div>

                <form onSubmit={handleEmailLogin} className="auth-form">         
                  <div className="form-group">
                    <input
                      type="email"
                      placeholder="Email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      required
                    />
                  </div>
                  <div className="form-group">
                    <input
                      type="password"
                      placeholder="Password"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      required
                    />
                  </div>
                  <button type="submit" className="auth-button">
                    {isLogin ? "Log in" : "Sign up"}
                  </button>
                  {authError && (
                    <p
                      style={{
                        color: "red",
                        fontSize: "0.9rem",
                        marginTop: "8px"
                      }}
                    >
                      {authError}
                    </p>
                  )}

                  <div className="auth-divider">
                    <span>Or Continue With </span>
                  </div>

                 <div className="social-buttons">
                    <button
                      type="button"
                      className="google-button"
                      onClick={handleGoogleLogin}
                    >
                      <img
                        src="https://www.google.com/favicon.ico"
                        alt="Google"
                        className="google-icon"
                        onError={(e) => {
                          e.target.onerror = null;
                          e.target.src =
                            "https://upload.wikimedia.org/wikipedia/commons/5/53/Google_%22G%22_Logo.svg";
                        }}
                      />
                      Google
                    </button>

                    <button
                      type="button"
                      className="apple-button"
                      onClick={handleAppleLogin}
                    >
                      <img
                        src="https://upload.wikimedia.org/wikipedia/commons/f/fa/Apple_logo_black.svg"
                        alt="Apple"
                        className="apple-icon"
                      />
                       Apple
                    </button>
                  </div>

                </form>

                <div className="auth-footer">
                  <p>
                    By continuing, you agree to iWinto's{" "}
                    <Link
                      to="/terms-of-services"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Terms of Service
                    </Link>{" "}
                    and acknowledge you've read our{" "}
                    <Link
                      to="/privacy-policy"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Privacy Policy
                    </Link>
                    .
                  </p>
                </div>
              </div>
            </div> */}
          </div>
        </section>
        <section className="search-section" id="animated-section">
          <div className="search-card">
            <div className="threephone-img-container">
              <img src={iphonemockup} alt="three phones" className="phone-image" />
            </div>
            <div className="search-content">
              <h2 className="title-animate">{t.discoverTitle || "A Profile That Matches Your Ambition"}</h2>
              <p className="text-animate">
                {t.discoverDescription || "Create Personalized Content That Helps Your Audience Reach You"}
              </p>
              {/* <button
        type="button"
        className="cta-button"
        onClick={() => scrollToSection(2)}
      >
        Start Exploring
      </button> */}
            </div>
          </div>
        </section>



        {/* Section 2: Post Your Idea */}
        {/* <section className="idea-section">
  <div className="idea-content">
    <h2>
      Post your next <br />
      <span key={activeIdeaIndex} className="changing-text fade-slide">
        {ideas[activeIdeaIndex].changingText}
      </span>
    </h2>

    <div className="idea-dots">
      {ideas.map((idea, index) => (
        <button
          key={idea.id}
          className={`idea-dot ${activeIdeaIndex === index ? 'active' : ''}`}
          onClick={() => handleDotClick(index)}
          aria-label={`Show ${idea.changingText}`}
        />
      ))}
    </div>
  </div>

  <div className="idea-images-scroll-container">
    <div className="idea-images-row">
      <div className="stack-column">
        {ideas[activeIdeaIndex].images
          .filter((img) => {
            const ids =
              activeIdeaIndex === 0
                ? [1, 2]
                : activeIdeaIndex === 1
                ? [10, 11]
                : [19, 20];
            return ids.includes(img.id);
          })
          .map((image, i) => (
            <div
              key={image.id}
              className="idea-image-wrapper fade-slide-img"
              style={{ '--i': i }}
            >
              <img src={image.src} alt="idea" className="idea-image" />
            </div>
          ))}
      </div>

      {ideas[activeIdeaIndex].images
        .filter((img) => {
          const idsToExclude =
            activeIdeaIndex === 0
              ? [1, 2, 8, 9]
              : activeIdeaIndex === 1
              ? [10, 11, 17, 18]
              : [19, 20, 26, 27];
          return !idsToExclude.includes(img.id);
        })
        .map((image, i) => {
          const translateY = getMiddleTranslateY(i + 1);
          return (
            <div
              key={image.id}
              className={`idea-image-wrapper middle-${i + 1} fade-slide-img`}
              style={{ '--i': i + 2, '--translateY': `${translateY}px` }}
            >
              <img src={image.src} alt="idea" className="idea-image" />
            </div>
          );
        })}

      <div className="stack-column">
        {ideas[activeIdeaIndex].images
          .filter((img) => {
            const ids =
              activeIdeaIndex === 0
                ? [9, 8]
                : activeIdeaIndex === 1
                ? [18, 17]
                : [27, 26];
            return ids.includes(img.id);
          })
          .map((image, i) => (
            <div
              key={image.id}
              className="idea-image-wrapper fade-slide-img"
              style={{ '--i': i + 7 }}
            >
              <img src={image.src} alt="idea" className="idea-image" />
            </div>
          ))}
      </div>
    </div>
  </div>
</section> */}
        <section className="landing-section">
          <div
            className="landing-scroll-wrapper"
            ref={landingRef}
            onScroll={e => setLandingAtTop(e.currentTarget.scrollTop === 0)}
          >

            <Hero />
            <DownloadButtons />
            <Feature />
            <Business />
            <Community />
            <AffiliationCard />
            <Categories />

            <div className="ads-with-bg">
              <Ads />
              <div className="masonry-wrapper-two">
                <div className="masonry-scroll-two">
                  {images.length === 0 ? (
                    <p style={{
                      padding: 20,
                      textAlign: 'center',
                      fontStyle: 'italic'
                    }}>
                      Loading images…
                    </p>
                  ) : (
                    getColumnData().map((column, columnIndex) => (
                      <div
                        key={columnIndex}
                        className={`masonry-column-two scroll-speed-${(columnIndex % 4) + 1}`}
                      >
                        {[...column, ...column].map((img, i) => (
                          <div
                            key={`${img.id}-${i}`}
                            className="masonry-item"
                            style={{ height: `${img.height}px` }}
                          >
                            <img
                              src={img.src}
                              alt=""
                              onError={() => handleImageError(img.id)}
                            />
                          </div>
                        ))}
                      </div>
                    ))
                  )}
                </div>
                <div className="fade-overlay-top"></div>

              </div>
            </div>
            <Footer />


          </div>
        </section>


      </div>
      <div className="mobile-signin-container">
        {currentUser ? (
          // Show "Go to Feed" button when authenticated
          <button
            className="mobile-signin-button"
            onClick={() => navigate('/feed')}
            style={{ backgroundColor: '#0088ff', color: 'white' }}
          >
            Go to Feed
          </button>
        ) : (
          // Show "Sign In" button when not authenticated
          <button className="mobile-signin-button" onClick={toggleAuth}>
            Sign In
          </button>
        )}
        <DownloadModal />
      </div>

      {/* Mobile Auth Dropdown */}
      <div
        ref={dropdownRef}
        className={`mobile-auth-dropdown ${isAuthOpen ? 'open' : ''}`}
      >
        <button
          className="mobile-auth-back"
          onClick={toggleAuth}
          aria-label="Close"
          title="Close"
        >
          <FiArrowLeft />
        </button>

        <div className="auth-form-container">
          <div className="auth-form-wrapper">
            <div className="auth-header">
              <div className="logo-border-radius">
                <img src={LogoCircular} alt="logo" />
              </div>
              <h1>Welcome to iWinto</h1>
              <DownloadModal />
            </div>

            <form
              onSubmit={handleSendOtp}
              className="auth-form"
            >
              {/* Sign-in method toggle */}
              <div className="auth-method-toggle">
                <button
                  type="button"
                  className={`method-btn ${signInMethod === 'email' ? 'active' : ''}`}
                  onClick={() => setSignInMethod('email')}
                >
                  Email
                </button>
                <button
                  type="button"
                  className={`method-btn ${signInMethod === 'phone' ? 'active' : ''}`}
                  onClick={() => setSignInMethod('phone')}
                >
                  Phone
                </button>
              </div>

              {signInMethod === 'email' ? (
                <div className="form-group">
                  <input
                    type="email"
                    placeholder="Enter your email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    autoComplete="email"
                    required
                  />
                </div>
              ) : (
                <div className="form-group phone-input-group">
                  <PhoneInput
                    placeholder="Enter phone number"
                    value={phoneNumber}
                    onChange={setPhoneNumber}
                    defaultCountry="LB"
                    international
                    withCountryCallingCode
                  />
                </div>
              )}

              <button type="submit" className="auth-button" disabled={isSubmitting}>
                {isSubmitting ? 'Sending code...' : 'Continue with OTP'}
              </button>
              {authError && <p className="auth-error">{authError}</p>}
            </form>

            <div className="auth-divider">
              <span>Or Continue With</span>
            </div>

            <div className="social-buttons">
              <button
                type="button"
                className="google-button"
                onClick={handleGoogleLogin}
                disabled={isSubmitting}
              >
                <img
                  src="https://www.google.com/favicon.ico"
                  alt="Google"
                  className="google-icon"
                />
                Google
              </button>
              <button
                type="button"
                className="apple-button"
                onClick={handleAppleLogin}
                disabled={isSubmitting}
              >
                <img
                  src="https://upload.wikimedia.org/wikipedia/commons/f/fa/Apple_logo_black.svg"
                  alt="Apple"
                  className="apple-icon"
                />
                Apple
              </button>
            </div>

            <div className="auth-toggle-row">
              <p style={{ textAlign: 'center', color: 'var(--text-secondary)', fontSize: '14px' }}>
                We'll send you a verification code to sign in or create an account.
              </p>
            </div>

            <div className="auth-footer">
              <p>
                By continuing, you agree to iWinto's{" "}
                <Link
                  to="/terms-of-services"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Terms of Service
                </Link>{" "}
                and acknowledge you've read our{" "}
                <Link
                  to="/privacy-policy"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Privacy Policy
                </Link>
                .
              </p>
            </div>
          </div>
        </div>
      </div>
      <FloatingWebsiteNavigation isAuthOpen={isAuthOpen} />
    </>
  );
};

export default Authentication;